import { render, staticRenderFns } from "./MyKombiCart.vue?vue&type=template&id=1f7ccaac&"
import script from "./MyKombiCart.vue?vue&type=script&lang=js&"
export * from "./MyKombiCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports